// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2koTI","item":"PaymentsMobile_item__u-GFD","label":"PaymentsMobile_label__242Gh","amount":"PaymentsMobile_amount__20N-z"};